import { RequestService } from '../request';

import { ICreateStudySessionResponse, IStudySession } from './voice.contract';

export interface ICreateSessionPayload {
  userName: string;
}

export class VoiceService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  public createStudySession(activityId: string, userName: string) {
    return this.poster<ICreateStudySessionResponse, ICreateSessionPayload>(
      `/voice/session/activity/${activityId}`,
      { userName }
    );
  }

  public getSession(sessionId: string) {
    return this.fetcher<IStudySession>(`/voice/session/${sessionId}`);
  }

  public endStudySession(sessionId: string) {
    return this.putter<IStudySession, void>(`/voice/session/${sessionId}/end`);
  }
}
